import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as mesasService from '../../services/mesas/mesasService';
import {
  classifyMesasError,
  toUpdateMesaPayload,
  validateMesaDatesInPeriodo,
  validateMesaDatesOK,
  validateMesaForm
} from '../../services/mesas/mesasDto';
import { LookupMaterias } from '../MateriaCarrera/LookupMaterias';
import { LookupPeriodoExamen } from '../PeriodoExamen/LookupPeriodoExamen';
import { parseDate, displayDate, todayCalendarDate } from '../../services/dates/dateService';
import { CalendarDatePicker } from '../common/CalendarDatePicker';

export class UpdateMesaExamen extends Component {
  static displayName = UpdateMesaExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingData: true,
      showErrorMessage: false,
      success: false,
      id: this.props.match.params.id,
      errorMessage: '',
      details: this.props.match.params.details,
      periodo: { codigo: 0, descripcion: '', fechaInicioPeriodo: todayCalendarDate(), fechaFinPeriodo: todayCalendarDate() },
      materia: { materiaCodigo: '', materiaCod: '', materiaNombre: '', carrera: '' },
      mesaExamen: { fechaExamen: todayCalendarDate(), fechaInicioInscripcion: todayCalendarDate(), fechaFinInscripcion: todayCalendarDate() },
      showLookupPeriodoCursada: false,
      showLookupMaterias: false,
    };
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWMesaExamen');
    if (canAccess) {
      await this.populateData();
    }
  }

  handleConfirmButton = () => {
    const okToSave = validateMesaForm({
      materiaPresent: this.state.materia.materiaCodigo.length > 0,
      periodoPresent: this.state.periodo.descripcion.length > 0
    });
    const fechasOk = validateMesaDatesOK(
      this.state.mesaExamen.fechaInicioInscripcion,
      this.state.mesaExamen.fechaFinInscripcion,
      this.state.mesaExamen.fechaExamen
    );
    const fechasEnPeriodo = validateMesaDatesInPeriodo({
      periodoInicio: this.state.periodo.fechaInicioPeriodo,
      periodoFin: this.state.periodo.fechaFinPeriodo,
      fechaExamen: this.state.mesaExamen.fechaExamen,
      fechaInicioInscripcion: this.state.mesaExamen.fechaInicioInscripcion,
      fechaFinInscripcion: this.state.mesaExamen.fechaFinInscripcion,
    });

    if (okToSave && fechasOk && fechasEnPeriodo) {
      this.saveStudent();
      return;
    }

    let errorMessage = '';
    if (!okToSave) {
      errorMessage = 'Todos los campos son obligatorios';
    } else if (!fechasOk) {
      errorMessage = 'Compruebe las fechas ingresadas, las fechas de inscripción deben ser menor a la fecha del examen';
    } else {
      errorMessage = 'Compruebe que las fechas se encuentren dentro del período de examen seleccionado';
    }
    this.setState({ showErrorMessage: true, errorMessage });
  };

  handleHideLookup = () => {
    this.setState({ showLookupMaterias: false });
  };

  handleStudentHideLookup = () => {
    this.setState({ showLookupPeriodoCursada: false });
  };

  handleShowStudentLookup = () => {
    this.setState({ showLookupPeriodoCursada: true });
  };

  handleShowCarreraLookup = () => {
    this.setState({ showLookupMaterias: true });
  };

  handleFechaExamen = (date) => {
    this.setState({
      mesaExamen: { ...this.state.mesaExamen, fechaExamen: date },
      showErrorMessage: false,
      errorMessage: '',
    });
  };

  handleFechaInicioInscripcion = (date) => {
    this.setState({
      mesaExamen: { ...this.state.mesaExamen, fechaInicioInscripcion: date },
      showErrorMessage: false,
      errorMessage: '',
    });
  };

  handleFechaFinInscripcion = (date) => {
    this.setState({
      mesaExamen: { ...this.state.mesaExamen, fechaFinInscripcion: date },
      showErrorMessage: false,
      errorMessage: '',
    });
  };

  handleSelectStudentItem = (e) => {
    const carreraProperties = e.split('%');
    this.setState({
      showLookupPeriodoCursada: false,
      showErrorMessage: false,
      errorMessage: '',
      periodo: {
        codigo: carreraProperties[0],
        descripcion: carreraProperties[1].trim() + ' - ' + carreraProperties[2].trim() + ' - ' + carreraProperties[3].trim(),
        fechaInicioPeriodo: parseDate(carreraProperties[4]),
        fechaFinPeriodo: parseDate(carreraProperties[5])
      }
    });
  };

  handleSelectCarreraItem = (e) => {
    const carreraProperties = e.split('%');
    this.setState({
      showLookupMaterias: false,
      showErrorMessage: false,
      errorMessage: '',
      materia: {
        materiaCodigo: carreraProperties[0].trim(),
        materiaCod: carreraProperties[1].trim(),
        materiaNombre: carreraProperties[2].trim(),
        carrera: carreraProperties[3].trim()
      }
    });
  };

  renderDateField({ id, label, value, onChange, isDetail, loading }) {
    if (isDetail) {
      return (
        <div className="md-page__field-readonly">
          {displayDate(value) || '\u00a0'}
        </div>
      );
    }

    return (
      <CalendarDatePicker
        inputId={id}
        className="md-page__field-input"
        selected={value}
        onChange={onChange}
        disabled={loading}
      />
    );
  }

  render() {
    if (this.state.success) {
      return <Redirect to="/md-mex" />;
    }

    const isDetail = this.state.details !== '0';
    const title = isDetail ? 'Detalle de Mesa de Examen' : 'Modificar Mesa de Examen';
    const { loading, loadingData } = this.state;
    const isBusy = loading || loadingData;
    const materiaDisplay = `${this.state.materia.materiaCod} - ${this.state.materia.materiaNombre} - ${this.state.materia.carrera}`.trim();
    const periodoDisplay = this.state.periodo.descripcion.trim();

    return (
      <div className="md-page md-update-mex">
        <Link className="md-page__back-link" to="/md-mex">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">{title}</h1>
        </div>
        <p className="md-page__subtitle">
          {isDetail
            ? 'Consulte los datos registrados de la mesa de examen.'
            : 'Actualice la materia, el período y las fechas de la mesa de examen.'}
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {this.state.errorMessage && !this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loadingData ? (
            <div className="md-page__status">Cargando datos...</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se están actualizando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <span className="md-page__field-label">Materia</span>
            {!isDetail && !isBusy ? (
              <div className="md-page__picker-block">
                <button type="button" className="md-page__picker-link" onClick={this.handleShowCarreraLookup}>
                  Seleccionar materia
                </button>
                <div className="md-page__field-readonly">{materiaDisplay || '\u00a0'}</div>
              </div>
            ) : (
              <div className="md-page__field-readonly">{materiaDisplay || '\u00a0'}</div>
            )}
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Período de examen</span>
            {!isDetail && !isBusy ? (
              <div className="md-page__picker-block">
                <button type="button" className="md-page__picker-link" onClick={this.handleShowStudentLookup}>
                  Seleccionar período de examen
                </button>
                <div className="md-page__field-readonly">{periodoDisplay || '\u00a0'}</div>
              </div>
            ) : (
              <div className="md-page__field-readonly">{periodoDisplay || '\u00a0'}</div>
            )}
          </div>

          <section className="md-page__form-section">
            <p className="md-page__form-section-title">Fechas</p>
            <div className="md-page__field">
              <label className="md-page__field-label" htmlFor="update-mex-fecha-examen">
                Fecha de examen
              </label>
              {this.renderDateField({
                id: 'update-mex-fecha-examen',
                label: 'Fecha de examen',
                value: this.state.mesaExamen.fechaExamen,
                onChange: this.handleFechaExamen,
                isDetail,
                loading: isBusy,
              })}
            </div>

            <div className="md-page__form-date-row">
              <div className="md-page__field">
                <label className="md-page__field-label" htmlFor="update-mex-inicio-inscripcion">
                  Inicio de inscripción
                </label>
                {this.renderDateField({
                  id: 'update-mex-inicio-inscripcion',
                  label: 'Inicio de inscripción',
                  value: this.state.mesaExamen.fechaInicioInscripcion,
                  onChange: this.handleFechaInicioInscripcion,
                  isDetail,
                  loading: isBusy,
                })}
              </div>

              <div className="md-page__field">
                <label className="md-page__field-label" htmlFor="update-mex-fin-inscripcion">
                  Fin de inscripción
                </label>
                {this.renderDateField({
                  id: 'update-mex-fin-inscripcion',
                  label: 'Fin de inscripción',
                  value: this.state.mesaExamen.fechaFinInscripcion,
                  onChange: this.handleFechaFinInscripcion,
                  isDetail,
                  loading: isBusy,
                })}
              </div>
            </div>
          </section>

          {!isDetail ? (
            <div className="md-page__form-actions">
              <button
                type="button"
                className="md-page__form-btn md-page__form-btn--primary"
                onClick={this.handleConfirmButton}
                disabled={isBusy}
              >
                Guardar cambios
              </button>
            </div>
          ) : null}
        </div>

        {this.state.showLookupMaterias ? (
          <LookupMaterias selectItem={this.handleSelectCarreraItem} hideLookup={this.handleHideLookup} />
        ) : null}
        {this.state.showLookupPeriodoCursada ? (
          <LookupPeriodoExamen selectItem={this.handleSelectStudentItem} hideLookup={this.handleStudentHideLookup} />
        ) : null}
      </div>
    );
  }

  async populateData() {
    this.setState({ loadingData: true });
    try {
      const returnModel = await mesasService.getMesa(this.state.id);
      this.setState({
        loadingData: false,
        errorMessage: '',
        showErrorMessage: false,
        periodo: {
          codigo: returnModel.peridoExamenCod,
          descripcion: returnModel.periodoExamenDescripcion.trim() + ' - '
            + returnModel.periodoExamenLlamado.trim() + ' - '
            + returnModel.anioAcademicoDescripcion,
          fechaInicioPeriodo: parseDate(returnModel.periodoExamenFechaInicio),
          fechaFinPeriodo: parseDate(returnModel.periodoExamenFechaFin)
        },
        materia: {
          materiaCodigo: returnModel.materiaCarreraCod.trim(),
          materiaNombre: returnModel.materiaCarreraNombre.trim(),
          materiaCod: (returnModel.materiaCarreraCodigo || returnModel.materiaCarreraCod || '').trim(),
          carrera: returnModel.carreraNombre.trim()
        },
        mesaExamen: {
          fechaExamen: parseDate(returnModel.mesaExamenFechaExamen),
          fechaInicioInscripcion: parseDate(returnModel.mesaExamenFechaInicioInscripci),
          fechaFinInscripcion: parseDate(returnModel.mesaExamenFechaFinInscripcion)
        }
      });
    } catch (error) {
      const outcome = classifyMesasError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({
        loadingData: false,
        errorMessage: outcome.message,
      });
    }
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await mesasService.saveMesa(
        toUpdateMesaPayload({
          id: parseInt(this.state.id, 10),
          periodoExamenCod: this.state.periodo.codigo,
          materiaCarreraCod: this.state.materia.materiaCodigo.trim(),
          fechaInicioInscripcion: this.state.mesaExamen.fechaInicioInscripcion,
          fechaFinInscripcion: this.state.mesaExamen.fechaFinInscripcion,
          fechaExamen: this.state.mesaExamen.fechaExamen
        })
      );
      this.setState({ loading: false, success: true, errorMessage: '' });
    } catch (error) {
      const outcome = classifyMesasError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({ loading: false, success: false, showErrorMessage: true, errorMessage: outcome.message });
    }
  }
}
